import React, {useEffect, useState} from "react";
import App from "../../routes/index";
import {useRouteMatch, useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Badge, Layout, Dropdown, Menu, Button} from "antd";
import {footerText} from "../../util/config";
import Sidebar from "../Sidebar";
import SidebarContent from "../Sidebar/SidebarContent";
import {BellFilled, CaretDownFilled, PoweroffOutlined, SettingOutlined} from "@ant-design/icons";
import {DOCUMENT_BASE_URL} from "../../constants/ServerUrl";
import {NoPageAccess} from "../../components/NoPageAccess";
import AlertNotification from "../Alert";
import {userSignOut} from "../../appRedux/actions";
import icon from '../../assets/images/assessment.png'
import NotificationWidget from "../../components/NotificationWidget";
import "../../components/NotificationWidget/notification.css";

const customNotifications = [
  {
    id: 1,
    type: 'notification',
    title: 'New Feature Released',
    message: 'Check out our new dashboard analytics feature!',
    priority: 'high',
    read: false,
    timestamp: new Date().toISOString()
  },
  {
    id: 2,
    type: 'training',
    title: 'How to give feedback on your manager appraisal',
    subtitle: 'Follow this guide on giving your feedback and satisfaction about your managers review',
    description: 'Complete this training to get started with the platform',
    priority: 'high',
    read: false,
    required: true, // This will force popup if forcePopup is enabled
    header: {
      background: '#f0f5ff',
      titleFontWeight: 800,
    },
    videoUrl: 'https://www.loom.com/embed/ac861547634e4b5e92d426c445ee4dee'
    // steps: [
    //   {
    //     id: 'welcome_video',
    //     type: 'video',
    //     title: 'Welcome',
    //     content: 'Welcome to our platform! This training will help you get started.',
    //     videoUrl: 'https://www.loom.com/embed/ac861547634e4b5e92d426c445ee4dee'
    //   },
    //   {
    //     id: 'navigation_video',
    //     type: 'video',
    //     title: 'Navigation',
    //     content: 'Learn how to navigate through different sections of the application.',
    //     videoUrl: 'https://www.loom.com/embed/ac861547634e4b5e92d426c445ee4dee'
    //   },
    //   {
    //     id: 'first_project_video',
    //     type: 'video',
    //     title: 'Creating Your First Project',
    //     content: 'Follow these steps to create your first project.',
    //     videoUrl: 'https://www.loom.com/embed/ac861547634e4b5e92d426c445ee4dee'
    //   },
    //   {
    //     id: 'onboarding_feedback',
    //     type: 'feedback',
    //     title: 'Quick Feedback',
    //     description: 'Any blockers or questions after watching the videos?'
    //   },
    //   {
    //     id: 'onboarding_quiz',
    //     type: 'quiz',
    //     title: 'Onboarding Check',
    //     passingScore: 70,
    //     questions: [
    //       {
    //         id: 'tq1',
    //         question: 'Where can you find your notifications?',
    //         type: 'multiple-choice',
    //         options: ['Payroll page', 'Notification widget', 'Leave module', 'Settings only'],
    //         correctAnswer: 1,
    //       },
    //     ],
    //   }
    // ]
  },
  {
    id: 3,
    type: 'quiz',
    title: 'Compliance Training Quiz',
    description: 'Complete this quiz to ensure you understand our compliance policies',
    priority: 'high',
    read: false,
    required: true,
    passingScore: 80,
    questions: [
      {
        id: 'q1',
        question: 'What should you do if you receive a suspicious email?',
        type: 'multiple-choice',
        options: [
          'Click on links to investigate',
          'Report it to IT security',
          'Forward it to colleagues',
          'Delete it immediately without reporting'
        ],
        correctAnswer: 1
      },
      {
        id: 'q2',
        question: 'Which of these are acceptable password practices?',
        type: 'multiple-select',
        options: [
          'Use at least 12 characters',
          'Include uppercase and lowercase letters',
          'Use your birthday as password',
          'Enable two-factor authentication'
        ],
        correctAnswers: [0, 1, 3]
      },
      {
        id: 'q3',
        question: 'How often should you change your password?',
        type: 'multiple-choice',
        options: [
          'Never',
          'Every 90 days or when compromised',
          'Every day',
          'Only when forced by the system'
        ],
        correctAnswer: 1
      }
    ]
  },
  {
    id: 4,
    type: 'survey',
    title: 'Q1 Feedback Survey',
    description: 'Share your thoughts on our Q1 initiatives',
    priority: 'medium',
    read: false,
    required: false,
    questions: [
      {
        id: 'feedback1',
        question: 'How would you rate the new features released in Q1?',
        type: 'rating',
        required: true
      },
      {
        id: 'feedback2',
        question: 'What features would you like to see in Q2?',
        type: 'textarea',
        required: false
      }
    ]
  },
  {
    id: 5,
    type: 'notification',
    title: 'Maintenance Scheduled',
    message: 'System maintenance scheduled for this weekend from 2 AM to 6 AM.',
    priority: 'medium',
    read: false,
    timestamp: new Date().toISOString()
  }
];

const handleComplete = (data) => {
    console.log('Notification completed:', data);
    
    // Here you can make API calls to save the completion status
    // For example:
    // await fetch('/api/notifications/complete', {
    //   method: 'POST',
    //   body: JSON.stringify(data)
    // });
};


const alert = "😊 Hey Champ!, Great work so far. Just a friendly reminder to checkout before leaving. Cheers! 👍"
const appraisalNotification = "Its appraisal period. Please complete your appraisal before February 4th"

const {Content, Sider, Header, Footer} = Layout;
const MainApp = () => {
    let [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    const match = useRouteMatch();
    const history = useHistory();

    const {authUser} = useSelector(({auth}) => auth);
    console.table(authUser)
    const dispatch = useDispatch();

    const menu = (
        <Menu>
          <Menu.Item>
            <p onClick={() => dispatch(userSignOut())} className="flex items-center text-gray-700 hover:text-gray-900">
                <PoweroffOutlined className="mr-2" />
                Sign Out
            </p>
          </Menu.Item>
          <Menu.Item>
            <p onClick={() => history.push('/account-settings')} className="flex items-center text-gray-700 hover:text-gray-900">
                <SettingOutlined className="mr-2" />
                Account Settings
            </p>
          </Menu.Item>
        </Menu>
      );


    return (
        <Layout className=""  style={{ position: 'relative' }}>

            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1000 }}>
                {
                   authUser && authUser.active_company == 1  && (
                    <>
                        {/* <AlertNotification message={appraisalNotification} hour={false} minute={false} icon={icon} celebrate={true} countdownTo="2026-02-04"></AlertNotification> */}
                        <AlertNotification message={alert}  hour="15" minute="44"> </AlertNotification>
                    </>
                   )
                }
               

            </div>

            <Sidebar sidebarCollapsed={sidebarCollapsed}/>
             {/* <NotificationWidget
                content={customNotifications}
                onComplete={handleComplete}
                forcePopup={true} // Set to true to force popup for required items
                maxForcedCloses={3}
                position="right" // or "left"
                viewMode="slider"
            ></NotificationWidget> */}
            <Layout>
                {/* <AlertNotification message={appraisalNotification}  hour={false} minute={false}> </AlertNotification> */}
                
                <Header className="bg-white p-0 h-20">

                    {authUser && (
                        <div className="flex justify-end space-x-10 mt-2 mr-5 md:mr-20 xl:mr-24">
                            <div className="hidden">
                                <Badge dot>
                                    <BellFilled/>
                                </Badge>
                            </div>

                            {authUser.profile_photo_path && (
                                    <div className="flex cursor-pointer">
                                        <div className="rounded-full p-1 flex-none">
                                            <img width="50" className="rounded-full" alt={authUser.first_name}
                                                src={`${DOCUMENT_BASE_URL}/${authUser.profile_photo_path}`}/>
                                        </div>
                                        <Dropdown overlay={menu} trigger={['click']} className="flex-shrink">
                                            {/* <Button className="items-center self-center ml-1"> */}
                                                <p className="font-semibold">
                                                    <CaretDownFilled className="pl-4"/>
                                                </p>
                                            {/* </Button> */}
                                        </Dropdown>
                                    </div>
                            )}
                            {!authUser.profile_photo_path && (
                                    <div className="flex cursor-pointer">
                                            <div className="rounded-full p-1 flex-none">
                                                <img width="50" className="rounded-full" alt="POSNL"
                                                    src="/images/app-icons/placeholder.jpg"/>
                                            </div>
                                            <Dropdown overlay={menu} trigger={['click']} className="flex-shrink">
                                                {/* <Button className="items-center self-center ml-1"> */}
                                                    <p className="font-semibold">
                                                        <CaretDownFilled className="pl-4"/>
                                                    </p>
                                                {/* </Button> */}
                                            </Dropdown>
                                    </div>
                            )}
                        </div>)}
                    {!authUser && (
                        <div className="flex justify-center md:justify-end space-x-10 mt-2 md:mr-20 xl:mr-24">
                            <div className="hidden">

                                <Badge dot>
                                    <BellFilled/>
                                </Badge>
                            </div>
                            <div className="flex cursor-pointer">
                                <div className="rounded-full p-1">

                                    <img width="50" className="rounded-full" alt="Phillips Outsourcing"
                                         src="/images/app-icons/placeholder.jpg"/>
                                </div>
                                <div>

                                    <p className="flex pl-3 font-semibold">Welcome<CaretDownFilled
                                        className="pl-4"/></p>
                                </div>
                            </div>


                        </div>

                    )}
                </Header>
                <Content className="overflow-auto h-screen">
                    {authUser && (
                        <>
                            {(authUser.employee_status_id.toString() !== "1") ? (
                                <NoPageAccess/>
                            ) : (<App match={match}/>)}
                        </>
                    )}

                    <Footer className="pl-3 md:px-0 md:mx-5 lg:mx-10">
                        <div className="gx-layout-footer-content">
                            {footerText}
                        </div>
                    </Footer>
                </Content>

            </Layout>
           
        </Layout>
    )
};
export default MainApp;

